import axios from "axios";
import Cookies from "js-cookie";
import { withApiError, withApiErrorResponse, apiErrorMessage } from "../utils/apiError";

const baseURL = process.env.REACT_APP_BASE_BACKEND_API_URL;
export const fetchCompletedTasks = async (selectedOrgId, fromDate, toDate) => {
  const token = Cookies.get("accessToken");

  // resolved params issue by harshit vachhani
  if (!selectedOrgId || !fromDate || !toDate) return [];

  try {
    const response = await axios.get(
      `${baseURL}api/v1/task/get-user-completed-tasks?organizationId=${selectedOrgId}&startDate=${fromDate}&endDate=${toDate}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.data?.body?.value) {
      return response.data.body.value;
    } else {
      console.error("Unexpected data format:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export const fetchDynamicWorkflows = async (projectId) => {
  const token = Cookies.get("accessToken");
  try {
    // resolved params issue by harshit vachhani
    if (!projectId) {
      return;
    }
    const response = await fetch(
      `${baseURL}api/v1/workflow/get-activities?projectId=${projectId}`, // update end point by harshit 23-12-2025
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const jsonData = await response.json();
    return jsonData.body.value;
  } catch (error) {
    console.error("Error fetching workflows:", error);
    return [];
  }
};

export const fetchDashboardNames = async (projectId, token) => {
  try {
    const response = await axios.get(
      `${baseURL}api/v1/activity-dashboard/get-dashboard-names`,
      {
        params: {
          projectId: projectId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("Error fetching dashboard names:", error);
    return [];
  }
};

export const fetchWorkflows = async (idForParam, token) => {
  try {
    const response = await axios.get(
      `${baseURL}api/v1/workflow/get-activities`, // update end point by harshit 23-12-2025
      {
        params: {
          projectId: idForParam,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("Error fetching workflows:", error);
    return [];
  }
};

export const fetchOrganizations = async () => {
  try {
    const response = await axios.get(`${baseURL}api/v1/organizations`);
    return withApiError(response.data);
  } catch (error) {
    console.error("Error loading organizations:", error);
    return [];
  }
};

//create dashboard

export const createDashboard = (formData, id) => {
  const token = Cookies.get("accessToken");

  return axios.post(
    `${baseURL}api/v1/activity-dashboard/create-dashboard`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

/**
 * GET api/v1/task/dashboard/governorate-count
 *
 * Per-governorate task counts broken down by status, for one workflow and
 * optionally one field agent. assigneeId is omitted entirely to mean
 * "all field agents".
 *
 * Returns [] rather than throwing when there is nothing to show, so the caller
 * renders an empty state instead of an error.
 */
export const fetchGovernorateTaskCounts = async ({ workflowId, assigneeId, signal } = {}) => {
  if (!workflowId) return [];

  const token = Cookies.get("accessToken");
  try {
    const response = await axios.get(`${baseURL}api/v1/task/dashboard/governorate-count`, {
      params: {
        workflowId,
        ...(assigneeId ? { assigneeId } : {}),
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "X-App-Type": "WEB",
      },
      signal,
    });

    // Application status rides in header.code; HTTP is 200 either way.
    if (response.data?.header?.code !== 600) return [];
    const value = response.data?.body?.value;
    return Array.isArray(value) ? value : [];
  } catch (error) {
    if (axios.isCancel(error) || error?.name === "CanceledError" || error?.name === "AbortError") {
      throw withApiErrorResponse(error);
    }
    console.error("Error fetching governorate task counts:", error);
    throw withApiErrorResponse(error);
  }
};

export const fetchTaskPriorityCount = async (workflowId,startDate,endDate) => {
  if (!workflowId) {
    console.warn("workflowId is required to fetch task priority count");
    return {};
  }

  const token = Cookies.get("accessToken");
  try {
    const response = await fetch(
      `${baseURL}api/v1/task/task-priority-count?workflowId=${workflowId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const jsonData = await response.json();
    return jsonData.body.value;
  } catch (error) {
    console.error("Error fetching data:", error);
    return {};
  }
};

export const fetchTaskStatusCount = async (workflowId, formattedStartDate, formattedEndDate) => {
  if (!workflowId) {
    console.warn("workflowId is required to fetch task priority count");
    return {};
  }

  const token = Cookies.get("accessToken");
  try {
    const response = await fetch(
      `${baseURL}api/v1/task/task-status-counts?workflowId=${workflowId}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const jsonData = await response.json();
    return jsonData.body.value;
  } catch (error) {
    console.error("Error fetching data:", error);
    return {};
  }
};

export const fetchUserCount = async (organizationId) => {
  const token = Cookies.get("accessToken");

  // Construct the URL based on userType
  let url = `${baseURL}api/v1/user/user-count`;

  url += `?organizationId=${organizationId}`;

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const jsonData = await response.json();
    return withApiError(jsonData);
  } catch (error) {
    console.error("Error fetching data:", error);
    return {};
  }
};

//activyt question
export const getFieldNames = async (dashboardNameInput) => {
  const token = Cookies.get("accessToken");

  if (!dashboardNameInput) return [];

  try {
    const response = await axios.get(
      `${baseURL}api/v1/workflow/get-field-names`,
      {
        params: {
          activityDashboardId: dashboardNameInput,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.body.value;
  } catch (error) {
    console.error("Error fetching dashboard names:", error);
    return [];
  }
};

// Fetch dashboard data
export const fetchDashboardData = async (dashboardNameInput, roleInput) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.get(
      `${baseURL}api/v1/activity-dashboard/get-dashboard`,
      {
        params: {
          activityDashboardId: dashboardNameInput,
          role: roleInput,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error fetching graph data:", error);
    throw withApiErrorResponse(error);
  }
};

export const createGraphMetric = async (
  dashboardNameInput,
  selectedChart,
  selectedFieldQuestionId,
  roleInput
) => {
  const token = Cookies.get("accessToken");
  const formData = {
    activityDashboardId: +dashboardNameInput,
    graphType: selectedChart,
    formFieldId: +selectedFieldQuestionId,
    role: roleInput,
  };

  try {
    const response = await axios.post(
      `${baseURL}api/v1/activity-dashboard/create-graph-metric`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error creating dashboard:", error);
    throw withApiErrorResponse(error);
  }
};

// Delete a dashboard
export const deleteDashboard = async (dashboardNameInput, roleInput) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_BACKEND_API_URL}api/v1/activity-dashboard/delete-dashboard`,
      {
        params: {
          activityDashboardId: dashboardNameInput,
          role: roleInput,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error deleting dashboard:", error);
    throw withApiErrorResponse(error);
  }
};

// Delete a graph metric
export const deleteGraphMetric = async (graphMetricId, roleForDelete) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_BACKEND_API_URL}api/v1/activity-dashboard/delete-graph-metric`,
      {
        params: {
          graphMetricId: graphMetricId,
          role: roleForDelete,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error deleting graph metric:", error);
    throw withApiErrorResponse(error);
  }
};

// generated data set for. power bi dashboard
export const fetchSyncWorkflow = async (departmentId) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.get(
      `${baseURL}reports?groupId=f74c9264-34d0-477f-b07b-288f52670ab4&departmentId=${departmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error fetching graph data:", error);
    throw withApiErrorResponse(error);
  }
};

// get FC Report - harshit vachhani - start
export const fetchFCReport = async () => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.get(
      `${baseURL}fc-reports?groupId=f74c9264-34d0-477f-b07b-288f52670ab4`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error fetching FC Report data:", error);
    throw withApiErrorResponse(error);
  }
};
// harshit vachhani - end

export const fetchSyncWorkflow2 = async (departmentId) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.get(
      `${baseURL}task/reports?groupId=f74c9264-34d0-477f-b07b-288f52670ab4&departmentId=${departmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error fetching graph data:", error);
    throw withApiErrorResponse(error);
  }
};

// embed report
export const fetchEmbedReport = async (reportId, datasetId) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.get(
      `${baseURL}embed-report`,
      {
        params: {
          groupId: "f74c9264-34d0-477f-b07b-288f52670ab4",
          reportId: reportId,
          datasetId: datasetId
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error fetching graph data:", error);
    throw withApiErrorResponse(error);
  }
};


export const clockInOutUser = async (organizationId, startDate, endDate) => {
  const token = Cookies.get("accessToken");

  // Construct the URL with startDate and endDate
  let url = `${baseURL}api/v1/user/clock-in-out?organizationId=${organizationId}`;
  if (startDate) {
    url += `&startDate=${startDate}`;
  }
  if (endDate) {
    url += `&endDate=${endDate}`;
  }

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData?.message ??
        (apiErrorMessage(errorData) || undefined)
      );
    }

    return withApiError(await response.json());
  } catch (error) {
    console.error('Error clocking in/out:', error);
    throw withApiErrorResponse(error);
  }
};

export const AvgTime = async (organizationId, startDate, endDate) => {
  const token = Cookies.get("accessToken");

  // Construct the URL with startDate and endDate
  let url = `${baseURL}api/v1/user/organization-work-summary?organizationId=${organizationId}&startDate=${startDate}&endDate=${endDate}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData?.message ??
        (apiErrorMessage(errorData) || undefined)
      );
    }

    return withApiError(await response.json());
  } catch (error) {
    console.error('Error clocking in/out:', error);
    throw withApiErrorResponse(error);
  }
};
